import script from "./ModelModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelModal.vue?vue&type=script&setup=true&lang=js"

import "./ModelModal.vue?vue&type=style&index=0&id=24e162e8&lang=css"
import "./ModelModal.vue?vue&type=style&index=1&id=24e162e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e162e8"]])

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QImg,QSpace,QToolbar,QDialog,QCard,QCardActions,QBtn,QCardSection,QTable});qInstall(script, 'directives', {ClosePopup});
